import { gql } from '@apollo/client'

export const DASHBOARD = gql`
  query {
    dashboard
  }
`
